import { render, staticRenderFns } from "./AdminDeleteAccountDialog.vue?vue&type=template&id=7005b325&scoped=true"
import script from "./AdminDeleteAccountDialog.vue?vue&type=script&lang=js"
export * from "./AdminDeleteAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7005b325",
  null
  
)

export default component.exports